function hasGrant(grant) {
    let grantList = window.sessionStorage.getItem('Grants');

    try {
        grantList = JSON.parse(grantList);

        if (grantList && grantList.constructor.name === "Array") {
            return grantList.includes(grant);
        }
        else {
            return false;
        }
    }
    catch (err) {
        return false
    }
}

export { hasGrant };